import { useCookies } from '@packages/shared/src/providers/CookieProvider/CookieProvider';
import { getEcState } from '@packages/shared/src/utils/ecState/ecState';
import { useSearchParams } from 'next/navigation';
import { getAllAudiences, getEcStateFromParams } from '../utils/audiences';
import { createFilterForCurrentAudiences, createFilterForTimeControl } from '../utils/filterResult';
import { previewPath } from '../components/Preview/previewPath';

export const useContentFilters = (
  options: { withTimeControl?: boolean; withAudienceControl?: boolean } = {},
) => {
  const searchParams = useSearchParams();
  const audienceParam = searchParams?.get('audience');

  const { withTimeControl = true, withAudienceControl = true } = options;

  const { getCookies } = useCookies();
  const cookies = getCookies();

  /**
   * For normal users the ecState comes from the cookie.
   * However, in the preview app, we'll need to simulate an ecState via query param "audiences".
   */
  const ecState =
    audienceParam && typeof window !== 'undefined' && window.document.URL.includes(previewPath)
      ? getEcStateFromParams(audienceParam)
      : getEcState(cookies);

  const audiences = getAllAudiences(ecState);
  const query = Object.fromEntries(useSearchParams()?.entries() ?? []);
  const { TestDate } = query;
  const res = [];
  if (withAudienceControl) {
    res.push(createFilterForCurrentAudiences(audiences));
  }
  if (withTimeControl) {
    res.push(createFilterForTimeControl(TestDate));
  }
  return res;
};
